/**
 * @mixin
 * Media queries methods
 */
export default {
  data() {
    return {
      mqMobile: window.matchMedia('(max-width : 575px)'),
      mqMobileExt: window.matchMedia('(max-width : 767px)'),
      mqDesktop: window.matchMedia('(min-width : 992px)'),
      mqLanguage992To1200: window.matchMedia('(min-width : 992px) and (max-width : 1200px)'),
      mqCarousel768: window.matchMedia('(min-width : 768px) and (max-width : 1023px)'),
      mqCarousel1024: window.matchMedia('(min-width : 1024px) and (max-width : 1399px)'),
      mqCarousel1400: window.matchMedia('(min-width : 1400px)'),
      mobile: false,
      mobileExt: false,
      desktop: false,
      carousel768: false,
      carousel1024: false,
      carousel1400: false,
      language992To1200: false
    };
  },

  created() {
    // Mobile
    this.matchMediaMobile(this.mqMobile);
    this.mqMobile.addListener(this.matchMediaMobile);
    // Mobile and Tablet Portrait
    this.matchMediaMobileExt(this.mqMobileExt);
    this.mqMobileExt.addListener(this.matchMediaMobileExt);
    // Desktop
    this.matchMediaDesktop(this.mqDesktop);
    this.mqDesktop.addListener(this.matchMediaDesktop);
    // Carousel 768px
    this.matchMediaCarousel768(this.mqCarousel768);
    this.mqCarousel768.addListener(this.matchMediaCarousel768);
    // Carousel 1024px
    this.matchMediaCarousel1024(this.mqCarousel1024);
    this.mqCarousel1024.addListener(this.matchMediaCarousel1024);
    // Carousel 1400px
    this.matchMediaCarousel1400(this.mqCarousel1400);
    this.mqCarousel1400.addListener(this.matchMediaCarousel1400);
    // Language 992px To 1200px
    this.matchMediaLanguage992To1200(this.mqLanguage992To1200);
    this.mqLanguage992To1200.addListener(this.matchMediaLanguage992To1200);
  },

  methods: {
    // Mobile
    matchMediaMobile(e) {
      this.mobile = !!e.matches;
    },

    // Mobile and Tablet Portrait
    matchMediaMobileExt(e) {
      this.mobileExt = !!e.matches;
    },

    // Desktop
    matchMediaDesktop(e) {
      this.desktop = !!e.matches;
    },

    // Carousel 768px
    matchMediaCarousel768(e) {
      this.carousel768 = !!e.matches;
    },

    // Carousel 1024px
    matchMediaCarousel1024(e) {
      this.carousel1024 = !!e.matches;
    },

    // Carousel 1400px
    matchMediaCarousel1400(e) {
      this.carousel1400 = !!e.matches;
    },

    // Language 992px To 1200px
    matchMediaLanguage992To1200(e) {
      this.language992To1200 = !!e.matches;
    }
  }
};
